import React, {useRef} from 'react';
import {SvgIcon} from '../../icons/svgIcon';
import {IconType} from '../../icons/icons';
import classNames from 'clsx';
import './hibuButton.scss';
import {HibuTooltip} from '../hibuTooltip/hibuTooltip';
import {Placement} from 'react-bootstrap/Overlay';

type InputProps = {
    visible: boolean;
    className?: string;
    onClick: (ref: React.RefObject<HTMLButtonElement>, e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    icon: IconType;
    tooltipKey?: string;
    size?: 'sm' | 'md';
    disabled?: boolean;
    placement?: Placement;
};

export const HibuButton = React.memo(({
                                          visible,
                                          className,
                                          onClick,
                                          icon,
                                          tooltipKey,
                                          size,
                                          disabled,
                                          placement
                                      }: InputProps) => {
    const buttonDOM = useRef<HTMLButtonElement>(null);

    if (!visible) {
        return null;
    }

    const hibuButton = (
        <button
            className={classNames('hibu-button', className, size || 'md')}
            onClick={(e) => onClick(buttonDOM, e)}
            ref={buttonDOM}
            disabled={disabled}
        >
            <SvgIcon icon={icon} />
        </button>
    );

    if (tooltipKey) {
        return <HibuTooltip tooltipKey={tooltipKey} placement={placement}>{hibuButton}</HibuTooltip>;
    }

    return hibuButton;
});
